/**
 * @file Pause icon (two vertical bars) used by terminal/workspace
 *       headers to suspend a running lab.
 * @module @labcraft/ui/icons/pause
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Pause icon — two vertical bars.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function PauseIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 12 12"
      width={12}
      height={12}
      fill="currentColor"
      aria-hidden
      {...props}>
      <rect x={3} y={2.5} width={2} height={7} rx={0.5} />
      <rect x={7} y={2.5} width={2} height={7} rx={0.5} />
    </svg>
  )
}
